import ContactBlockView from '@/src/contact/presentation/components/blocks/contact-block-view/contact-block-view';
import css from '@/src/home/presentation/views/home-page.view.css';

export function HomePageView() {
  return (
    <div className={css.page}>
      <div className={css.innerPage}></div>

      <ContactBlockView />
    </div>
  );
}
